import React, { useState, useEffect, useMemo } from 'react';
import moment from 'moment';

import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import { AdapterMoment } from '@mui/x-date-pickers/AdapterMoment';

import Modal from '../../modals/Modal';
import Autocomplete from '../../shared/Autocomplete';

import { sortAlphabetically } from '../../../util/utils';

import { defaultLeadDays } from '../../../constants/cases';

const CaseDateModal = (props) => {
  const {
    open,
    onClose,
    selectedCase,
    onSubmit,
    hospitals = [],
    loading,
    isAdmin,
    procedures = [],
  } = props;

  const [date, setDate] = useState(
    isAdmin ? moment() : moment().add(defaultLeadDays, 'days')
  );
  const [hospital, setHospital] = useState(null);

  const procedure = useMemo(
    () => procedures?.find((p) => p.id === selectedCase?.procedure),
    [selectedCase, procedures]
  );

  const leadDays = useMemo(
    () => (procedure ? (procedure?.leadDays || 0) + 10 : defaultLeadDays),
    [procedure]
  );

  const startDate = useMemo(
    () => (isAdmin ? moment() : moment().add(leadDays, 'days')),
    [leadDays, isAdmin]
  );

  useEffect(() => {
    if (startDate) {
      setDate(startDate);
    }
  }, [startDate]);

  useEffect(() => {
    if (open && selectedCase) {
      setHospital(selectedCase?.hospitalUniq?.id);
    }
  }, [open, selectedCase]);

  return (
    <Modal
      open={open}
      onClose={onClose}
      title={selectedCase?.formattedId || selectedCase?.id}
      subtitle="Case ID"
      submitButton="Save Changes"
      onSubmit={() => onSubmit(date, hospital)}
      size="md"
      autoSize
      closeButton="Cancel"
      disabled={loading}
      loading={loading}
    >
      <LocalizationProvider dateAdapter={AdapterMoment}>
        <div className="d-flex direction-column space-between" style={{ minWidth: 300 }}>
          <div className="p-lg width-100">
            <div className="secondary">Surgery Date</div>
            <DatePicker
              desktopModeMediaQuery="(min-width: 0px)"
              format="DD/MM/YYYY"
              value={date}
              onChange={(newDate) => setDate(newDate)}
              minDate={!isAdmin ? startDate : undefined}
              slotProps={{
                textField: {
                  fullWidth: true,
                  variant: 'standard',
                },
              }}
            />
          </div>

          <div className="p-l-lg p-r-lg p-b-lg width-100">
            <Autocomplete
              value={hospital}
              onChange={setHospital}
              options={[...hospitals].sort(sortAlphabetically('name'))}
              getOptionLabel={(option) => option.name}
              label="Hospital"
            />
          </div>
        </div>
      </LocalizationProvider>
    </Modal>
  );
};

export default CaseDateModal;
